import React from "react";
import RadioChecked from "icons/RadioChecked";
import RadioUnChecked from "icons/RadioUnChecked";
import "./RadioGroup.scss";
import map from "lodash/map";

type RadioGroupProps = {
  onCheck: (value: any) => void;
  items: { label: string; value: string }[];
  value: string;
  name?: string;
};

const RadioGroup: React.FC<RadioGroupProps> = ({
  onCheck,
  items,
  value,
  name,
}) => {
  const groupName = React.useRef(
    `radio-group-${Math.random().toString(36).slice(2, 11)}`,
  ).current;

  return (
    <fieldset className="radio-group">
      {name && <legend className="sr-only">{name}</legend>}
      {map(items, (item) => {
        const isChecked = value === item.value;
        const inputId = `${groupName}-${item.value}`;
        return (
          <label key={item.value} className="radio">
            <input
              id={inputId}
              type="radio"
              name={groupName}
              value={item.value}
              checked={isChecked}
              onChange={() => onCheck(item.value)}
              className="radio-input"
            />
            {isChecked && <RadioChecked />}
            {!isChecked && <RadioUnChecked />}
            <div>{item.label}</div>
          </label>
        );
      })}
    </fieldset>
  );
};

export default RadioGroup;
